module.exports = {
	"githubLink": "https://github.com/corpglory/d3vue/",
	"d3ComponentsPath": "tree/master/src/d3-components"
};


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 35
// module chunks = 1